import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../../src/app/admin/services/notification.service';
import { ApiserviceService } from '../../../../../../src/app/apiservice.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-manage-price-filter',
  templateUrl: './manage-price-filter.component.html',
  styleUrls: ['./manage-price-filter.component.scss']
})
export class ManagePriceFilterComponent implements OnInit {
  @Input() columnNameList = [];
  @Output() resetFilter = new EventEmitter<void>();
  @Output() dataRange = new EventEmitter<any>();
  @Output() sendFilteredSectionData = new EventEmitter<any[]>();
  @Output() filterOptionsChanged = new EventEmitter<any>();
  @Input() emittedIndex: number | null = null;

  dynamicForm: FormGroup;
  options: any;
  placeholder: string = 'Enter';
  type: string = '';
  selectedDateRange: [string, string] | null = null;

  // Variables to store added_date, updated_date, and date_range
  addedDate: string | null = null;
  updatedDate: string | null = null;
  dateRange: string | null = null;
  transactionDate: string | null = null;
  startDate: string | null = null;
  endDate: string | null = null;
  entityTypesList: string[] = [];
  searchText: string = ''; 
  private subs = new Subscription();

  filterValueDataType: { [key: string]: string } = {
    added_by: 'number',
    added_date: 'date',
    area: 'number',
    date: 'date',
    entity_type: 'text',
    government_id: 'text',
    outlier: 'boolean',
    prop_type_estater: 'text',
    prop_type_govt: 'text',
    property_uid: 'text',
    source_name: 'text',
    source_type: 'text',
    transaction_id: 'number',
    transaction_type: 'text',
    transaction_value: 'number',
    unit_uid: 'text',
    updated_by: 'number',
    updated_date: 'date',
    year: 'number',
    transaction_uid: 'text',
    prop_govt_id: 'number',
    unit_govt_id: 'number',
    area_range: 'number',
    start_date: 'date',
    end_date: 'date',
    duration: 'number',
    payment_term: 'text',
    property_category: 'text',
    property_sub_category: 'text',
    unit_type: 'text',
    unit_sub_type: 'text',
    total_units_covered: 'number',
    floor_number: 'number',
    floor_type: 'text',
    neigh_name: 'text',
    block_no: 'number',
    parcel_no: 'text',
    plan_no: 'text'

  };
  transDataList: any;
  transOptions: any;
  selectedYear: number;
  currentYear: number;
  startYear: number;
  enityType = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly notify: NotificationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly apiService:ApiserviceService
  ) {
    this.dynamicForm = this.fb.group({
      rows: this.fb.array([this.createRow()])
    });
    this.currentYear = new Date().getFullYear();
    this.startYear = 2009;
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columnNameList']) {
      if (this.columnNameList && this.columnNameList.length > 0) {
        this.options = this.columnNameList.map((column: string) => ({
          value: column,
          label: column
        }));
      }
    }
    if (this.emittedIndex !== null) {
      this.removeRow(this.emittedIndex);
      this.getFilteredOptions(this.emittedIndex);
    }
  }
  ngOnInit(): void {
    this.getTransType()
  // Using spread operator (better practice)
  this.enityType = [
    { value: "property", label: "property" },
    { value: "unit", label: "unit" },
    { value: "unit_individual", label: "unit individual" },
    { value: "property_unmapped", label: "property unmapped" },
    { value: "unit_unmapped", label: "unit unmapped" },
    { value: "unit_range", label: "unit range" }
  ];

  }
  get rows(): FormArray {
    return this.dynamicForm.get('rows') as FormArray;
  }

  createRow(): FormGroup {
    return this.fb.group({
      columnName: [null, Validators.required],
      columnValue: ['', Validators.required]
    });
  }

  addRow(): void {
    // Validate form and check if any date fields are populated
    if (this.dynamicForm.invalid) {
      this.notify.notify(
        'Enter a valid value before adding a new item',
        'warn'
      );
      return;
    }

    // Add a new row
    this.rows.push(this.createRow());
    this.cdr.detectChanges();
  }

  removeRow(index: number): void {
    const rows = this.dynamicForm.get('rows') as FormArray;
    if (rows.length > 1) {
      rows.removeAt(index);
    } else {
      this.resetForm();
    }
  }

  removeRowFromChips(index: number): void {

    const rows = this.dynamicForm.get('rows') as FormArray;

    // Remove the row at the specified index
    if (rows.length > 1) {
      rows.removeAt(index);
    } else {
      this.resetForm(); // Reset the form if it's the last chip
      this.resetFilter.emit(); // Notify parent to reset
    }

    // Emit the updated filter options
    const selectedFilterOptions = this.dynamicForm.value.rows.filter(row => row.columnName && row.columnValue);
    this.filterOptionsChanged.emit(selectedFilterOptions);

    // Handle the case where no filters remain
    if (selectedFilterOptions.length === 0) {
      this.resetFilter.emit(); // Notify parent to reset
    }
  }



  resetForm(): void {
    const rows = this.dynamicForm.get('rows') as FormArray;

    while (rows.length > 1) {
      rows.removeAt(rows.length - 1);
    }

    rows.at(0).reset({
      columnName: null,
      columnValue: ''
    });

    this.resetFilter.emit();
    this.dynamicForm.markAsPristine();
    this.dynamicForm.markAsUntouched();

    this.addedDate = null;
    this.updatedDate = null;
    this.dateRange = null;
    this.transactionDate = null;
    this.startDate = null;
    this.endDate = null;
  }

  getFilteredOptions(index: number) {
    if (!this.options || !Array.isArray(this.options)) {
      return [];
    }

    const selectedValues = this.rows.controls
      .map((control) => control.get('columnName')?.value)
      .filter((value) => value);

    return this.options.filter(
      (option) =>
        !selectedValues.includes(option.value) ||
        selectedValues[index] === option.value
    );
  }

  onSelectionChange(index: number): void {
    const selectedRow = this.rows.at(index);
    const selectedColumn = selectedRow.get('columnName')?.value;

    // Reset the columnValue when columnName changes
    selectedRow.patchValue({
      columnValue: '' // Clear the input or dropdown selection
    });

    if (selectedColumn) {
      const inputType = this.filterValueDataType[selectedColumn];
      this.type = inputType;

      if (selectedColumn === 'added_date') {
        this.addedDate = null; // Clear any stored added_date value
      } else if (selectedColumn === 'updated_date') {
        this.updatedDate = null; // Clear any stored updated_date value
      }

      if (selectedColumn === 'transaction_type') {
        this.getTransType();
      }

      this.placeholder = inputType;
    }
  }

  getEntityType() {
    const entityTypeSub = this.apiService.getEmsData('entities')
      .subscribe(
        (data: any) => {
          this.entityTypesList = data;
        }
      );
      this.subs.add(entityTypeSub);
  }


  onDateRangeSelected(dateRange: [string, string], rowIndex: number): void {
    const selectedRow = this.rows.at(rowIndex); // Get the specific row
    const columnName = selectedRow.get('columnName')?.value; // Get the column name for this row

    // Format the date range as "YYYY/MM/DD-YYYY/MM/DD"
    const formattedDateRange = `${dateRange[0]}-${dateRange[1]}`;

    // Assign the formatted date range to the respective column
    if (columnName === 'added_date') {
      this.addedDate = formattedDateRange; // Store the formatted string for added_date
    } else if (columnName === 'updated_date') {
      this.updatedDate = formattedDateRange; // Store the formatted string for updated_date
    } else if (columnName === 'date') {
      this.dateRange = formattedDateRange; // Store the formatted string for date
    }else if (columnName === 'transaction_date') {
      this.transactionDate = formattedDateRange; // Store the formatted string for date
    }else if (columnName === 'start_date') {
      this.startDate = formattedDateRange; // Store the formatted string for date
    }else if (columnName === 'end_date') {
      this.endDate = formattedDateRange; // Store the formatted string for date
    }

    // Update the form's columnValue with the formatted date range
    selectedRow.patchValue({
      columnValue: formattedDateRange
    });
  }


  onSubmit(): void {
    if (!this.dynamicForm.valid && !this.dateRange) {
      this.notify.notify('Select one filter at least for apply filter', 'warn');
      return;
    } else {
      const selectedFilterOptions = this.dynamicForm.value.rows;
      this.sendFilteredSectionData.emit(selectedFilterOptions);
      this.dataRange.emit(this.dateRange);
    }
  }

  isDateColumn(row: any): boolean {
    const columnName = row.get('columnName').value;
    return columnName === 'added_date' || columnName === 'updated_date' || columnName === 'transaction_date' || columnName === 'start_date' || columnName === 'end_date';
  }

  getTransType(): void {
    const url = `master-values-by-master?master_name=transaction_upload_option&entity=property`;
    const transSub = this.apiService.getEmsData(url).subscribe({
      next: (res: any) => {
        this.transDataList = res.data;
        this.transOptions = this.transDataList.map((item: any) => ({
          value: item.master_value_name,
          label: item.master_value_name
        }));
      },
      error: (err) => console.error('Error fetching Trans Type options:', err),
    });
    this.subs.add(transSub);
  }
  onTransSelectionChange(index: number, event: any): void {
    const selectedRow = this.rows.at(index);
    if (!selectedRow) {
      console.error('No row found at index:', index);
      return;
    }
    // Ensure columnValue is patched correctly
    selectedRow.patchValue({
      columnValue: event, // Fallback to an empty string if value is undefined
    });
    this.dynamicForm.updateValueAndValidity();
  }
  onEntitySelectionChange(index: number, event: any): void {
    const selectedRow = this.rows.at(index);
    if (!selectedRow) {
      console.error('No row found at index:', index);
      return;
    }
    // Ensure columnValue is patched correctly
    selectedRow.patchValue({
      columnValue: event, // Fallback to an empty string if value is undefined
    });
    this.dynamicForm.updateValueAndValidity();
  }
  // Handles the chosen year for the date picker
  handleYearSelected(year: number) {
    this.selectedYear = year;
  }

  onSearchTextChange(searchValue: string) {
    this.searchText = searchValue;
  }

  ngondestroy(): void {
    this.subs.unsubscribe();
  }
}
